import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { styled, Typography, Chip } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import StorefrontIcon from "@mui/icons-material/Storefront";
import MopedIcon from "@mui/icons-material/Moped";
import { CCard } from "../../components/common/CCard";

export default function DeliveryTypeTab({
  deliveryType,
  setDeliveryType,
  deliveryTabOptions,
}) {
  const handleChange = (event, newValue) => {
    setDeliveryType(newValue);
  };
  React.useEffect(() => {
    if (
      (deliveryType === "DOOR_STEP_DELIVERY" &&
        deliveryTabOptions?.door_step_delivery) ||
      (deliveryType === "PICK_UP" && deliveryTabOptions?.pick_up)
    ) {
      return;
    }

    if (deliveryTabOptions?.door_step_delivery) {
      setDeliveryType("DOOR_STEP_DELIVERY");
    } else if (deliveryTabOptions?.pick_up) {
      setDeliveryType("PICK_UP");
    }
  }, [deliveryTabOptions]);

  return (
    <CCard>
      <HeaderBox>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 600,
            color: "var(--neutral-black)",
            fontSize: { xs: "14px", sm: "16px" },
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          {deliveryType === "DOOR_STEP_DELIVERY" ? (
            <LocalShippingIcon
              sx={{ fontSize: 20, color: "var(--primary-red-base)" }}
            />
          ) : (
            <StorefrontIcon
              sx={{ fontSize: 20, color: "var(--primary-red-base)" }}
            />
          )}
          Delivery Options
        </Typography>
      </HeaderBox>

      <TabsContainer>
        <ModernTabs
          value={deliveryType}
          onChange={handleChange}
          textColor="inherit"
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            "& .MuiTabs-flexContainer": {
              gap: 1.5,
            },
          }}
        >
          {deliveryTabOptions?.door_step_delivery && (
            <ModernTab
              value="DOOR_STEP_DELIVERY"
              label={
                <TabContent>
                  <TabTitle>Home Delivery</TabTitle>
                  {deliveryTabOptions?.showDeliveryTypeCount && (
                    <CountBadge>
                      {deliveryTabOptions?.door_step_products?.size}
                    </CountBadge>
                  )}
                </TabContent>
              }
            />
          )}

          {deliveryTabOptions?.pick_up && (
            <ModernTab
              value="PICK_UP"
              label={
                <TabContent>
                  <TabTitle>Store Pickup</TabTitle>
                  {deliveryTabOptions?.showDeliveryTypeCount && (
                    <CountBadge>
                      {deliveryTabOptions?.pick_up_products?.size}
                    </CountBadge>
                  )}
                </TabContent>
              }
            />
          )}
        </ModernTabs>
      </TabsContainer>
    </CCard>
  );
}

export const HeaderBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingBottom: theme.spacing(1.5),
  borderBottom: "1px solid #e5e7eb",
  backgroundColor: "#fff",
}));

const TabsContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#fff",
  padding: "24px 0 8px 0",
  [theme.breakpoints.down("sm")]: {
    padding: "16px 0 8px 0",
  },
}));

const ModernTabs = styled(Tabs)(({ theme }) => ({
  "& .MuiTabs-flexContainer": {
    justifyContent: "space-around",
    padding: "0 4px",
    width: "100%",
    gap: theme.spacing(1),
  },
}));

const ModernTab = styled(Tab)(({ theme }) => ({
  flex: 1,
  padding: "12px 22px",
  borderRadius: "8px",
  textTransform: "none",
  backgroundColor: "var(--neutral-100)",
  border: "1.5px solid var(--neutral-600) !important",
  color: "var(--neutral-700)",
  transition: "all 0.2s ease",
  boxSizing: "border-box",
  "&:hover": {
    backgroundColor: "#f1f5f9",
    borderColor: "#cbd5e1 !important",
  },
  "&.Mui-selected": {
    color: "#ef4444",
    backgroundColor: "#fef2f2",
    border: "1.5px solid #ef4444 !important",
    fontWeight: 600,
    width: "100%",
  },
  "& .MuiTab-iconWrapper": {
    fontSize: "20px",
    marginRight: 0,
    marginBottom: theme.spacing(1),
  },
}));

const TabContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "calc('100% - 20px')",
  textAlign: "center",
}));

const TabTitle = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: 1.2,
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

const CountBadge = styled(Box)(({ theme }) => ({
  minWidth: "20px",
  height: "20px",
  borderRadius: "10px",
  backgroundColor: "#ef4444",
  color: "white",
  fontSize: "11px",
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0 6px",
  marginTop: theme.spacing(0.5),
}));
